let initialState = "nnn";
const updtoken = (state = "", action) => {

    switch(action.type){ 
      case "SETUPDTOKEN" : return action.parm;
      case "RESET": return initialState; //Always return the initial state
      default : return state;
  }
}

export default updtoken